import SignalAlertTable from './SignalAlertTable';
export default SignalAlertTable;
